interface ContentSectionProps {
  content: string;
  author: {
    name: string;
    avatar: string;
    bio: string;
  };
}

export default function ContentSection({ content, author }: ContentSectionProps) {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 max-w-6xl mx-auto">
        <article className="lg:w-[65%]">
          <div
            className="prose-custom text-foreground-800 text-sm md:text-base leading-relaxed space-y-4"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </article>

        <aside className="lg:w-[35%]">
          <div className="bg-secondary-900 rounded-2xl p-6 md:p-8 sticky top-24">
            <div className="flex items-center justify-between mb-6">
              <span className="text-xs font-semibold text-secondary-300/60 uppercase tracking-wider">
                关于作者
              </span>
              <div className="flex items-center gap-1">
                <span className="w-1.5 h-1.5 rounded-full bg-secondary-300/40"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-secondary-300/40"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-secondary-300/40"></span>
              </div>
            </div>

            <blockquote className="text-white text-sm md:text-base leading-relaxed mb-6">
              "{author.bio}"
            </blockquote>

            <div className="flex items-center justify-between pt-5 border-t border-secondary-700/50">
              <div className="flex items-center gap-3">
                <img
                  src={author.avatar}
                  alt={author.name}
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
                />
                <div>
                  <p className="text-white text-sm font-semibold whitespace-nowrap">
                    {author.name}
                  </p>
                  <p className="text-secondary-300/60 text-xs whitespace-nowrap">
                    签约作者
                  </p>
                </div>
              </div>

              <button className="px-3 py-1.5 rounded-lg bg-secondary-700/50 text-secondary-200 text-xs font-medium hover:bg-secondary-600/50 transition-colors whitespace-nowrap flex items-center gap-1">
                关注 <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}